import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import DialogTemplate from '@/_components/dialog/template/template.vue'
import Role from '@/views/Authorization/models/role'

@Component({
    inheritAttrs: false,
    name: 'RoleDelete',
    components: { DialogTemplate },
})
export default class RoleDelete extends Mixins<MixinInterface>() {
    @Prop({ required: true }) props!: any

    get role(): Role {
        return this.props.role
    }

    testText = ''
    loading = false

    get testPassed() {
        return this.testText.toLowerCase() == this.role['name'].toLowerCase()
    }

    async deleteRole() {
        if (this.testPassed) {
            this.loading = true
            await this.role.deleteRole().catch((error) => (this.loading = false))
            this.$emit('close', true)
            this.loading = false
        }
    }
}
